import React, { useState } from "react";
import { Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { trackQuestion } from "@reducers/trackerSlice";
import { Div, Button, Image } from "@components/Generics.react";
import { clientAssetsPath } from "@api/apiV6";
import ResponseOverlay from "@components/ResponseOverlay.react";

export default function PictureFuddle(props) {
    const { data, slideSeq, trackData, deckId, pageNumber, setPageNumber } =
        props;
    const [correct, setCorrect] = useState(null);
    const [ansval, setAnsval] = useState("");
    const [showOverlay, setShowOverlay] = useState(false);
    const userId = useSelector((state) => state.auth.user._id);
    const dispatch = useDispatch();
    const { t } = useTranslation("common");

    function handleChange(e) {
        setAnsval(e.target.value);
    }

    function trackInteraction() {
        const isCorrect = data.answer.toLowerCase() === ansval.toLowerCase();
        setCorrect(isCorrect);
        setShowOverlay(true);
        if (trackData) {
            trackData({
                correct: isCorrect,
                response: ansval,
            });
            dispatch(
                trackQuestion({
                    deckId: deckId,
                    slideId: slideSeq,
                    userId: userId,
                    response: ansval,
                })
            );
        }
    }

    function closeOverlay() {
        setPageNumber(pageNumber + 1);
    }

    // ========================= Render Function =================================
    return (
        <Div fluid fullht zoom superpad relative>
            <Image fluid rounded src={`${clientAssetsPath}/uploads/qdf/slides/${data.image?.id}${data.image?.extension}`} />
            <Div big padTop gutter>
                {data.question}
            </Div>
            <Div small italics>
                {t("deck.qdf.fitb")}
            </Div>
            <Div padTop>
                <Input
                    size="big"
                    fluid
                    placeholder={data.answer.replace(/[^-\s]/g, "*")}
                    value={ansval}
                    onChange={handleChange}
                />
                <Button
                    content={"Submit"}
                    fluid
                    primary
                    onClick={trackInteraction}
                />
            </Div>
            {showOverlay && (
                <ResponseOverlay
                    feedback={data.feedback}
                    correct={correct}
                    closeResponse={closeOverlay}
                />
            )}
        </Div>
    );
}
